const AVATAR_COLOR_MAP = ["neutral", "blue", "red", "orange", "yellow", "teal", "purple"];

export const getAvatarColorForIndex = (index: number): string => {
    return AVATAR_COLOR_MAP[index % 7];
}